const ENV_SUBDOMAINS = new Set(['staging', 'staging2', 'demo', 'agent', 'www']);

export const getCanonicalTenantUrl = (input) => {
    const url = new URL(input);
    const match = url.hostname.match(/^([a-z0-9_-]+)\.(?:(?:staging|staging2|demo)\.)?leasehub\.app$/i);
    if (!match || !match[1].includes('_')) return null;
    const canonical = match[1].replaceAll('_', '');
    if (!canonical) return null;
    url.hostname = canonical + url.hostname.slice(match[1].length);
    if (url.searchParams.get('client_id') === match[1]) {
        url.searchParams.set('client_id', canonical);
    }
    return url.href;
};

const labelsOf = (hostname) => hostname.split('.').filter(Boolean);
const isLocalhostHost = (hostname) =>
    hostname === 'localhost' || hostname.endsWith('.localhost');

const hostHasClientSubdomain = (hostname) => {
    const parts = labelsOf(hostname);

    if (isLocalhostHost(hostname)) {
        return parts.length >= 2 && parts[0] !== 'localhost';
    }
    if (parts.length >= 4) return true;
    if (parts.length === 3) return !ENV_SUBDOMAINS.has(parts[0]);
    return false;
};

export const getSubdomainClientId = (hostnameInput) => {
    const hostname = (hostnameInput || window.location.hostname || '').split(':')[0];
    if (!hostname) {
        return null;
    }

    const parts = hostname.split('.').filter(Boolean);
    if (parts.length <= 1) {
        return null;
    }

    const subdomain = parts[0];
    if (!subdomain || subdomain === 'www') {
        return null;
    }

    return subdomain;
};

export const appendClientIdQueryParam = (url, clientId) => {
    if (!clientId) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}client_id=${encodeURIComponent(clientId)}`;
};

export const getClientSubdomainOrigin = (domainName) => {
    const canonicalUrl = getCanonicalTenantUrl(window.location.origin);
    const origin = canonicalUrl ? new URL(canonicalUrl).origin : window.location.origin;
    if (!domainName) return origin;
    const canonicalDomain = domainName.replaceAll('_', '');
    if (!canonicalDomain) return origin;

    let url;
    try {
        url = new URL(origin);
    } catch {
        return origin;
    }

    if (!url.hostname || hostHasClientSubdomain(url.hostname)) return origin;

    const portSuffix = url.port ? `:${url.port}` : '';
    return `${url.protocol}//${canonicalDomain}.${url.hostname}${portSuffix}`;
};
